import { useQuery } from "react-query";
import axios from "infra/http";
import { ParametrosAssembleia } from "../typings";

function useParametrosAssembleia(tenantId: string) {
  return useQuery(
    `/v1/parametros-votacao/${tenantId}`,
    async () => {
        const { data } = await axios.get<ParametrosAssembleia>(
        `/v1/parametros-votacao/${tenantId}`
        );

        return data;
    },
    {
      enabled: !!tenantId,
    }
  );
}

export default useParametrosAssembleia;
